import React from 'react';
import { ActivationCard } from './ActivationCard';

interface ExpiredScreenProps {
  onStartOver: () => void;
  title?: string;
  message?: string;
}

export const ExpiredScreen: React.FC<ExpiredScreenProps> = ({
  onStartOver,
  title = 'Activation Expired',
  message = 'Your activation code has expired. Please start the registration process again.',
}) => (
  <ActivationCard>
    <div className="text-center">
      <div className="mb-4">
        <i className="fas fa-clock text-danger" style={{ fontSize: '4rem' }}></i>
      </div>
      <h1 className="h3 mb-3 fw-bold">{title}</h1>
      <p className="text-muted mb-4">{message}</p>
      <div className="alert alert-danger" role="alert">
        <i className="fas fa-exclamation-circle me-2"></i>
        The activation code is no longer valid.
      </div>
      <button onClick={onStartOver} className="btn btn-primary w-100">
        <i className="fas fa-redo me-2"></i>
        Start Over
      </button>
    </div>
  </ActivationCard>
);
